<!-- AudioSequentialPlayer.vue -->
<template>
    <span class="audio-logo">
        <SafeIcon
                type="ai-yinpin"
                :class="{ 'audio-active': isPlaying }"
                class="audio-icon paper-primary-text"/>
    </span>
</template>

<script setup>
    import { onUnmounted, defineProps} from 'vue'


    defineProps({
        isPlaying: {
            type: Boolean,
            default: false
        }
    });


    // 清理资源
    onUnmounted(() => {
        console.log('boke onUnmounted');
        // if (audioPlayer.value) {
        //     audioPlayer.value.pause();
        //     audioPlayer.value = null
        // }
    })
</script>

<style scoped>
    .audio-logo{
        background: #FFF;
        border-radius: 30px;
        border: 1px solid #ccc;
        padding: 14px 7px 6px;
    }

    .audio-icon {
        font-size: 24px!important;
        transition: all 0.3s;
    }

    .audio-active {
        animation: pulse 1s infinite;
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(1.2);
            opacity: 0.7;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

</style>